import Vue from 'vue'
import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import responseHandler from "@/plugins/errorHandling";
import {IService, IServiceTag} from "@/model/Service/serviceInterfaces";

interface ServiceProviderServiceState {
  services: IService[];
  service: IService;
  tags: IServiceTag[];
  errors: IErrors;
}

const state: ServiceProviderServiceState = {
  services: [],
  service: {} as IService,
  tags: [],
  errors: {},
};

const getters: GetterTree<ServiceProviderServiceState, RootState> = {
  services: (state) => state.services,
  service: (state) => state.service,
  tags: (state) => state.tags,
  errors: (state) => state.errors,
};

const actions: ActionTree<ServiceProviderServiceState, RootState> = {
  fetchServiceProvidersServices: ({ commit }, data): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/services',
      method: "GET",
    }),
    commit,
    'servicesLoaded'
  ),
  fetchService: ({ commit }, data: { spId: number, serviceId: number }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/services/' + data.serviceId,
      method: "GET",
    }),
    commit,
    'serviceLoaded'
  ),
  createService: ({ commit }, data: { spId: number, service: Partial<IService> }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/services',
      method: "POST",
      data: data.service,
    }),
    commit,
    'serviceCreated'
  ),
  updateService: ({ commit }, data: { spId: number, serviceId: number, service: Partial<IService> }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/services/' + data.serviceId,
      method: "PATCH",
      data: data.service,
    }),
    commit,
    'serviceUpdated'
  ),
  fetchTags: ({ commit }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/serviceTags',
      method: "GET",
    }),
    commit,
    'tagsLoaded'
  ),
  deleteService: ({ commit }, data: { spId: number, serviceId: number }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/services/' + data.serviceId,
      method: "DELETE",
    }),
    commit,
    'serviceDeleted'
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
  cleanError: ({commit}, index: any): any => {
    commit('cleanError', index);
  },
};

const mutations: MutationTree<ServiceProviderServiceState> = {
  servicesLoaded(state, payload) {
    state.services = payload;
  },
  serviceLoaded(state, payload) {
    state.service = payload;
  },
  tagsLoaded(state, payload) {
    state.tags = payload;
  },
  serviceCreated(state, payload) {
    state.service = payload;
  },
  serviceUpdated(state, payload) {
    state.service = payload;
  },
  serviceDeleted() {
    // handled by navigation
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
  cleanError(state, index: string) {
    Vue.delete(state.errors, index);
  },
};

const namespaced: boolean = true;

export const serviceProviderServiceModule: Module<ServiceProviderServiceState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
